// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  location: 'qa',
  //API_URL: 'https://qnbn-app-tca-be-dv-we-01-c5b5chg0hug6dzbd.westeurope-01.azurewebsites.net',
  API_URL: 'https://localhost:7240', // Updated to match backend launchSettings.json
  //API_URL: 'https://qnbn-apim-vp-dv-we.azure-api.net/tca',
  APIM_SUBSCRIPTION_KEY: 'a9ca3ad62bd84a4ca38cff4916ef62ae',
  //API_URL: 'https://vendor-api-dev.qnbn.qa',
  //API_URL: 'https://4549-20-21-220-217.ngrok-free.app',
  // API_URL: 'https://vendor-api-stg.qnbn.qa',
  // API_URL: 'https://vendor-api.qnbn.qa',
  APIs_PREFIX: 'api',
  MICROSOFT_AUTH_CONFIG_KEY: 'YOUR_BASE64_32_BYTE_KEY_HERE',
  pageSize: 5,
  // Disable all backend connections - Change this to false to re-enable connections
  DISABLE_BACKEND: true, // Demo mode: every backend request is served locally
  // Azure Speech Service Configuration
  AZURE_SPEECH: {
    subscriptionKey: '3kEFTM2MRR52qLeEMDeM7Ew0XrG5Awgeg7Knzrttp089mQezXXLeJQQJ99CBAC5RqLJXJ3w3AAAYACOGGYPP', // Copy KEY 1 or KEY 2 from Azure Portal (Keys and Endpoint section)
    region: 'westeurope', // Your region from Azure Portal
    language: 'en-US' // Default language for speech recognition
  }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
